<template>
  <q-expansion-item
    v-for="item in menu"
    :key="item.id"
    :header-inset-level="deepLevel / 5"
    :class="['item', { item__active: PAGES[item.menu_action] === path }]"
    header-class="item__header"
    :label="item.menu_name"
    :to="getHref(item.menu_action)"
    :hide-expand-icon="!item.sub_menus?.length"
    expand-icon-class="item__exp_icon"
  >
    <template #header="props">
      <div
        class="q-item__section q-item__section--main"
        style="display: flex; align-items: center; gap: 7px;"
      >
        <q-icon
          v-if="deepLevel === 0"
          :name="`svguse:/img/icons/slice.svg#${menuIcons[item.icon.toLowerCase()] ? item.icon.toLowerCase() || 'document' : 'document'}|${menuIcons[item.icon.toLowerCase()] ? menuIcons[item.icon.toLowerCase()].viewBox : '0 0 20 20'}`"
          size="32px"
          class="tw-text-primary-light"
          viewport="0 0 10 17"
        />
        <div
          :class="['q-item__section q-item__section--main justify-between tw-flex tw-items-center tw-gap-1.5', {item__active: PAGES[item.menu_action] === path, 'tw-text-primary-light': isItemActive(item)}]"
        >
          <span>{{ item.menu_name }}</span>
          <span
            v-if="getMenuItemWhatHighlight(item)"
            class="tw-inline-block tw-h-2 tw-w-2 tw-shrink-0 tw-rounded-full tw-bg-red-600"
            aria-hidden="true"
          />
          <span
            v-if="getClosingDocumentsCount(item) !== null"
            class="tw-inline-flex tw-h-5 tw-min-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-orange-500 tw-px-1 tw-text-xs tw-font-semibold tw-text-white tw-leading-none"
          >{{ getClosingDocumentsCount(item) }}</span>
          <q-tooltip v-if="!!getMenuTooltip(item)">
            {{ getMenuTooltip(item) }}
          </q-tooltip>
        </div>
      </div>
    </template>

    <menu-list
      v-if="item.sub_menus"
      :menu="item.sub_menus"
      :deep-level="deepLevel + 1"
    />
  </q-expansion-item>
</template>

<script>
import { mapState } from 'pinia'
import { PAGES } from '@/constants'
import { useAppStore } from '@/services/store/app'
import { menuIcons } from './services'

export default {
  name: 'menu-list',
  props: {
    menu: {
      type: Array,
      required: true
    },
    deepLevel: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {PAGES, menuIcons}
  },
  computed: {
    ...mapState(useAppStore, ['menuStatusBadges']),
    path () {
      return this.$route?.path ? this.$route.path : '/'
    },
  },
  methods: {
    getMenuItemWhatHighlight (item) {
      const action = item.menu_action
      if (action === 'unsignedSign') {
        const s = this.menuStatusBadges?.hasUnsignedAny
        if (s !== null && s !== undefined) return !!s
        return typeof item.what === 'boolean' && item.what
      }
      if (action === 'employeeTasks') {
        const s = this.menuStatusBadges?.hasOpenEmployeeTasks
        if (s !== null && s !== undefined) return !!s
        return typeof item.what === 'boolean' && item.what
      }
      return typeof item.what === 'boolean' && item.what
    },
    getHref (menu_action) {
      if (!menu_action || !PAGES[menu_action] || PAGES[menu_action]?.includes(':')) return
      return PAGES[menu_action]
    },
    matchesPath (pattern, currentPath) {
      if (!pattern) return false
      if (!pattern.includes(':')) {
        return currentPath === pattern || currentPath.startsWith(pattern + '/')
      }

      const escape = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      let regexStr = '^' + pattern
        .split('/')
        .map(seg => seg.startsWith(':') ? '[^/]+' : escape(seg))
        .join('/')
      regexStr += '(?:/.*)?$'

      try {
        return new RegExp(regexStr).test(currentPath)
      } catch (e) {
        return currentPath === pattern
      }
    },
    isItemActive (item) {
      const pattern = this.PAGES[item.menu_action]
      const selfActive = this.matchesPath(pattern, this.path)
      // const children = Array.isArray(item.sub_menus) ? item.sub_menus : []
      // return children.some(child => this.isItemActive(child))

      return selfActive
    },
    getMenuTooltip (item) {
      if (!this.getMenuItemWhatHighlight(item)) return null
      if (item.menu_action === 'unsignedSign') {
        return 'Есть не подписанные документы'
      }
      if (item.menu_action === 'employeeTasks') {
        return 'Есть невыполненные задачи'
      }
      return null
    },
    getClosingDocumentsCount (item) {
      if (item.menu_action !== 'closingDocuments') return null
      const count = this.menuStatusBadges?.closingDocumentsCount
      if (count === null || count === undefined) return null
      return count
    }
  }
}
</script>

<style lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;

.item {
  color: $gray-dark;
  padding: 0;
  border: none;
    border-radius: 10px;

  &__header {
    min-height: 40px !important;
    border-radius: 10px;
  }

  .q-icon {
    font-size: 18px !important;
  }
  &__link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    padding: 8px 16px;
    width: 100%;

    &_icon { min-width: 40px; }
    &_dot { font-size: 8px !important; }
  }

  &__exp {
    &_icon {
      font-size: 20px !important;
      color: $gray-dark;
      .q-icon {
        font-size: 12px !important;
      }
    }
  }

  &__active {
    background: $background;
    color: $primary-light;
  }
}
</style>
